/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/
// ==========================================
// CART BUILD GROUPING LOGIC (GLOBAL)
// ==========================================

window.toggleBuildParts = function(buildId, btnElement) {
  const container = document.getElementById('build_children_' + buildId);
  if (!container) return;
  
  const icon = btnElement.querySelector('.toggle-icon');
  
  if (container.style.display === 'none') {
    container.style.display = 'block';
    if (icon) icon.innerText = '▲';
  } else {
    container.style.display = 'none';
    if (icon) icon.innerText = '▼';
  }
};

window.removeBuild = async function(buildId, event) {
  if (event) event.preventDefault();
  if (!confirm("Are you sure you want to remove this entire Custom Build?")) return;
  
  try {
    // 1. Fetch current cart to get all item keys
    const cartRes = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js');
    const cart = await cartRes.json();
    
    // 2. Find all items belonging to this buildId
    const updates = {};
    cart.items.forEach(item => {
      if (item.properties && item.properties._build_id === buildId) {
        updates[item.key] = 0; // Set quantity to 0 to remove
      }
    });
    
    // 3. Send bulk update to Shopify
    const updateUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js';
    await fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    
    // 4. Reload page or trigger theme's cart update (easiest is reload)
    window.location.reload();
    
  } catch (err) {
    console.error(err);
    alert('Failed to remove custom build: ' + err.message);
  }
};

(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.





  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
